import classNames from "classnames";
import React from "react";

import InputLabel from "./InputLabel";
import styles from "./index.module.scss";

interface Props {
  hasBottom?: boolean;
  inputName?: string;
  requiredLabel?: boolean;
  columnMultiple?: boolean;
}

class LabelAndInputBox extends React.PureComponent<Props> {
  public render() {
    const {
      children,
      hasBottom = false,
      inputName,
      columnMultiple,
      requiredLabel = false,
    } = this.props;

    const wrapperClass = classNames(styles.inputsWrapper, {
      [styles.singleBox]: hasBottom,
    });
    return (
      <div className={wrapperClass}>
        {inputName ? (
          <>
            <InputLabel label={inputName} required={requiredLabel} />
            {columnMultiple ? (
              <div className={styles.inputsContainerWithLabel}>{children}</div>
            ) : (
              <div className={styles.inputsContainerWithLabel}>{children}</div>
            )}
          </>
        ) : (
          <div className={styles.inputsContainer}>{children}</div>
        )}
      </div>
    );
  }
}

export { LabelAndInputBox };
export { default as ErrorRow } from "./ErrorRow";
export { default as InputColumn } from "./InputColumn";
export { default as InputRow } from "./InputRow";
export { default as Inputs } from "./Inputs";
export { default as Instruction } from "./Instruction";
export { default as InputLabel } from "./InputLabel";
